import { render } from "./TheBarChartStatistics.vue?vue&type=template&id=8b35e76c&scoped=true"
import script from "./TheBarChartStatistics.vue?vue&type=script&lang=js"
export * from "./TheBarChartStatistics.vue?vue&type=script&lang=js"

import "./TheBarChartStatistics.vue?vue&type=style&index=0&id=8b35e76c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b35e76c"]])

export default __exports__